<template>
  <v-dialog v-model="visible" max-width="550" persistent>
    <v-card>
      <v-card-title class="text-h6"> Skapa nyhet </v-card-title>

      <v-card-text>
        <v-text-field
          label="Nyhetens namn"
          clearable
          hide-details="true"
          outlined
          v-model="title"
        ></v-text-field>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text :to="{ name: 'NewsList' }"> Avbryt </v-btn>

        <v-btn color="primary" :disabled="!title" :loading="loading" @click="save"> Spara </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { dateTimeToday } from '../../lib/misc'

export default {
  name: 'NewsCreate',
  data() {
    return {
      visible: true,
      title: '',
      loading: false,
    }
  },
  methods: {
    ...mapActions('news', { createNews: 'create' }),
    ...mapActions('content', { createContent: 'create' }),
    async save() {
      this.loading = true
      const { id } = await this.createNews({
        news_title: this.title,
        news_date_added: dateTimeToday,
        news_date_origin: dateTimeToday,
        news_publish: 'offline',
        tags:[]
      })
      await this.createContent({ type: 'news', parent_id: id, data: `<p>${this.title}</p>` })
      this.loading = false
      this.$router.replace({ name: 'SingleNews', params: { id } })
    },
  },
}
</script>

<style lang="scss" scoped></style>
